var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

// src/api/config.ts
function resolveBaseUrl() {
  if (typeof import.meta !== "undefined" && import.meta.env?.VITE_API_URL !== void 0) {
    return import.meta.env.VITE_API_URL;
  }
  if (typeof process !== "undefined" && process.env?.NEXT_PUBLIC_API_URL) {
    return process.env.NEXT_PUBLIC_API_URL;
  }
  return "http://localhost:5050";
}
__name(resolveBaseUrl, "resolveBaseUrl");
var API_BASE_URL = resolveBaseUrl();
var REQUEST_TIMEOUT_MS = 15e3;
var ROUTES = {
  auth: {
    login: "/api/v1/auth/login",
    register: "/api/v1/auth/register",
    refresh: "/api/v1/auth/refresh",
    forgotPassword: "/api/v1/auth/forgot-password",
    resetPassword: "/api/v1/auth/reset-password",
    verifyEmail: "/api/v1/auth/verify-email",
    roles: "/api/v1/auth/roles",
    users: "/api/v1/auth/users",
    // admin-only (gateway route-role map)
    userCount: "/api/v1/auth/users/count",
    // manager+ — staff-seat count only, no PII
    google: "/api/v1/auth/google",
    // anonymous — exchanges a real Google ID token
    guest: "/api/v1/auth/guest",
    // anonymous — creates a passwordless guest-checkout account
    me: "/api/v1/auth/me",
    inviteStoreOwner: "/api/v1/auth/invite-store-owner",
    // platform admin only
    acceptStoreInvite: "/api/v1/auth/accept-store-invite"
    // anonymous — the token is the credential
  },
  quotes: "/api/v1/quotes",
  bookings: "/api/v1/bookings",
  jobs: "/api/v1/jobs",
  // Distinct from `jobs` above (that's the scheduled-visit entity) — "Post a Job" customer
  // postings, matched against workers by area+skill. customer|manager (gateway route-role map).
  jobPostings: "/api/v1/job-postings",
  catalog: {
    serviceAreas: "/api/v1/catalog/service-areas",
    packages: "/api/v1/catalog/packages",
    items: "/api/v1/catalog/items",
    roomTypes: "/api/v1/catalog/room-types"
  },
  catalogAdmin: "/api/v1/catalog-admin",
  // manager+
  campaigns: "/api/v1/campaigns",
  // manager+
  blog: {
    base: "/api/v1/blog",
    // manager+ list/get/create/update/delete
    public: "/api/v1/blog/public",
    categories: "/api/v1/blog/categories"
    // anonymous
  },
  schedule: "/api/v1/schedule",
  // manager+
  customers: "/api/v1/customers",
  cms: {
    sections: "/api/v1/cms/sections",
    // manager+
    public: /* @__PURE__ */ __name((page) => `/api/v1/cms/public/${encodeURIComponent(page)}`, "public")
  },
  testimonials: {
    base: "/api/v1/testimonials",
    // manager+ list/create/update/delete
    public: "/api/v1/testimonials/public"
  },
  subscriptions: {
    plans: "/api/v1/subscriptions/plans",
    // manager+ read; admin write
    tenant: "/api/v1/subscriptions/tenant",
    // manager+, own tenant
    tenantUpgrade: "/api/v1/subscriptions/tenant/upgrade",
    tenantCancel: "/api/v1/subscriptions/tenant/cancel",
    tenantCheckout: "/api/v1/subscriptions/tenant/checkout",
    // real Stripe Checkout Session
    tenantPortal: "/api/v1/subscriptions/tenant/portal",
    // real Stripe Customer Portal
    allTenants: "/api/v1/subscriptions/tenants",
    // admin only
    dashboard: "/api/v1/subscriptions/dashboard",
    // admin only
    tenantsExportCsv: "/api/v1/subscriptions/admin/tenants/export.csv",
    // admin only
    tenantDiscount: /* @__PURE__ */ __name((tenantId) => `/api/v1/subscriptions/admin/tenants/${tenantId}/discount`, "tenantDiscount"),
    // admin only
    tenantRefund: /* @__PURE__ */ __name((tenantId) => `/api/v1/subscriptions/admin/tenants/${tenantId}/refund`, "tenantRefund"),
    // admin only
    tenantFeatures: /* @__PURE__ */ __name((tenantId) => `/api/v1/subscriptions/admin/tenants/${tenantId}/features`, "tenantFeatures"),
    // admin only
    analyticsMrr: "/api/v1/subscriptions/admin/analytics/mrr",
    // admin only
    analyticsChurn: "/api/v1/subscriptions/admin/analytics/churn",
    // admin only
    analyticsDistribution: "/api/v1/subscriptions/admin/analytics/distribution",
    // admin only
    analyticsMrrExportCsv: "/api/v1/subscriptions/admin/analytics/mrr/export.csv"
    // admin only
  },
  tenants: {
    base: "/api/v1/tenants",
    // platform admin only (TenantsController) — the tenant registry itself
    deactivate: /* @__PURE__ */ __name((id) => `/api/v1/tenants/${id}/deactivate`, "deactivate")
  },
  site: {
    base: "/api/v1/site",
    // manager+ get/upsert
    public: "/api/v1/site/public"
  },
  images: {
    base: "/api/v1/images",
    // POST (upload, manager+) / GET+DELETE {**fileName}
    // ImagesController.List uses [HttpGet("~/api/v1/images-admin")] — an absolute route
    // override, so this is NOT nested under `base` despite living in the same controller.
    admin: "/api/v1/images-admin"
    // manager+ list
  },
  contacts: "/api/v1/contacts",
  // GET/PUT/DELETE manager+; POST /public is anonymous
  messages: "/api/v1/messages",
  // any authenticated role (no gateway route-role entry)
  workers: "/api/v1/workers",
  // worker|manager
  checkins: "/api/v1/checkins",
  // worker|manager
  media: "/api/v1/media",
  invoices: "/api/v1/invoices",
  payments: "/api/v1/payments",
  // manager+
  paymentIntent: "/api/v1/payments/create-intent",
  // customer,manager
  paymentRefund: "/api/v1/payments/refund",
  // manager+
  accounting: "/api/v1/accounting",
  // manager+
  reports: {
    generate: "/api/v1/reports/generate",
    // manager+
    list: "/api/v1/reports",
    // manager+
    get: /* @__PURE__ */ __name((id) => `/api/v1/reports/${id}`, "get"),
    // manager+
    download: /* @__PURE__ */ __name((id) => `/api/v1/reports/${id}/download`, "download"),
    // manager+
    delete: /* @__PURE__ */ __name((id) => `/api/v1/reports/${id}`, "delete"),
    // manager+
    schedules: "/api/v1/reports/schedules",
    // manager+
    schedule: /* @__PURE__ */ __name((id) => `/api/v1/reports/schedules/${id}`, "schedule")
    // manager+
  },
  products: "/api/v1/products",
  // anonymous reads; manager+ writes (in-service gated)
  categories: "/api/v1/categories",
  // anonymous reads; manager+ writes (in-service gated)
  heroSlides: "/api/v1/hero-slides",
  // anonymous reads; manager+ writes (in-service gated)
  promoTiles: "/api/v1/promo-tiles",
  // anonymous reads; manager+ writes (in-service gated)
  productCampaigns: "/api/v1/product-campaigns",
  // anonymous reads; manager+ writes (in-service gated)
  discounts: {
    rules: "/api/v1/discounts/rules",
    // manager+
    ruleAnalytics: /* @__PURE__ */ __name((id) => `/api/v1/discounts/rules/${id}/analytics`, "ruleAnalytics"),
    // manager+
    validate: /* @__PURE__ */ __name((code) => `/api/v1/discounts/validate/${encodeURIComponent(code)}`, "validate"),
    // anonymous
    calculate: "/api/v1/discounts/calculate"
    // customer,manager
  },
  locations: {
    base: "/api/v1/locations",
    // anonymous reads; manager+ writes
    copyTo: /* @__PURE__ */ __name((id, targetId) => `/api/v1/locations/${id}/copy-to/${targetId}`, "copyTo"),
    // manager+
    productPricing: /* @__PURE__ */ __name((productId) => `/api/v1/products/${productId}/pricing`, "productPricing"),
    // manager+
    bulkPricing: "/api/v1/products/bulk-pricing",
    // manager+
    countries: "/api/v1/locations/countries",
    // anonymous
    regions: "/api/v1/locations/regions",
    // anonymous
    suburbs: /* @__PURE__ */ __name((locationId) => `/api/v1/locations/${locationId}/suburbs`, "suburbs")
    // anonymous reads; manager+ writes
  },
  // Native ProductService image/video upload for Products/HeroSlides/Campaigns — NOT
  // TenantService's `images` above. GET (serving) is anonymous; POST/DELETE are manager+
  // (in-service gated), same "anonymous prefix, controller-gated writes" shape as `products`.
  productMedia: "/api/v1/product-media",
  loyalty: "/api/v1/loyalty",
  // tiers anonymous; me/enroll customer+; tier CRUD + members manager+ (in-service gated)
  referrals: "/api/v1/referrals",
  // me/redeem customer+; stats manager+ (in-service gated)
  // Public reads/create live under /api/v1/products/{id}/reviews (see productsApi/reviewsApi
  // split below); this is only the manager-only moderation surface.
  productReviews: "/api/v1/product-reviews",
  wishlist: "/api/v1/wishlist",
  // customer+ (analytics/top narrowed to manager+ at the gateway)
  cart: "/api/v1/cart",
  // anonymous (guest) or customer
  orders: "/api/v1/orders",
  // customer,manager
  notifications: "/api/v1/notifications",
  // customer,manager (test-send + admin list are manager-only, gateway-narrowed)
  notificationTemplates: "/api/v1/notification-templates",
  // manager+
  opsOrderDlq: "/api/v1/ops/order/dlq",
  // admin only
  permissions: "/api/v1/permissions",
  // admin only
  roles: "/api/v1/roles",
  // admin only
  analytics: "/api/v1/analytics",
  // manager+
  ai: {
    chat: "/ai/chat",
    chatSeed: "/ai/chat/seed",
    chatSession: /* @__PURE__ */ __name((id) => `/ai/chat/sessions/${encodeURIComponent(id)}`, "chatSession"),
    recommendations: /* @__PURE__ */ __name((productId, limit) => `/ai/recommendations/${encodeURIComponent(productId)}?limit=${limit}`, "recommendations"),
    // manager+ only (RouteAuthorization) — real per-feature Prometheus counters and a
    // Redis-backed audit log, see ai-engine/app/routers/verification.py.
    usageStats: "/ai/usage-stats",
    auditLogs: /* @__PURE__ */ __name((limit = 50) => `/ai/audit-logs?limit=${limit}`, "auditLogs"),
    // Real tool-calling agents (LangGraph ReAct over ai-engine's own MCP server). agentChat is
    // anonymous (storefront shopping agent); the other two require a manager JWT — real
    // gateway-enforced RouteAuthorization, not just a frontend convention.
    agentChat: "/ai/agent/chat",
    analyticsAgentChat: "/ai/analytics-agent/chat",
    supportAgentChat: "/ai/support-agent/chat"
  },
  registry: "/registry",
  health: "/health",
  // TenantService/NewsletterController — subscribe/unsubscribe are anonymous "*"; list is
  // manager+ (gateway-narrowed from the wide-open TenantService base tier).
  newsletter: {
    subscribe: "/api/v1/newsletter/public",
    unsubscribe: /* @__PURE__ */ __name((id) => `/api/v1/newsletter/public/unsubscribe/${encodeURIComponent(id)}`, "unsubscribe"),
    list: /* @__PURE__ */ __name((activeOnly = true) => `/api/v1/newsletter?activeOnly=${activeOnly}`, "list")
  }
};
var API_CONFIG = { baseURL: API_BASE_URL };

// src/api/errors.ts
var _ApiError = class _ApiError extends Error {
  constructor(status, problem, correlationId2 = null) {
    super(problem.title ?? `Request failed (${status})`);
    __publicField(this, "status");
    __publicField(this, "problem");
    __publicField(this, "correlationId");
    this.name = "ApiError";
    this.status = status;
    this.problem = problem;
    this.correlationId = correlationId2;
  }
  /** Short slug from the problem `type` URI, e.g. "validation-failed". */
  get code() {
    return this.problem.type?.split("/").pop() ?? "unknown";
  }
};
__name(_ApiError, "ApiError");
var ApiError = _ApiError;
var _ValidationError = class _ValidationError extends ApiError {
  constructor(problem, correlationId2) {
    super(400, problem, correlationId2);
    __publicField(this, "fieldErrors");
    this.name = "ValidationError";
    this.fieldErrors = problem.errors ?? [];
  }
};
__name(_ValidationError, "ValidationError");
var ValidationError = _ValidationError;
var _AuthError = class _AuthError extends ApiError {
  constructor(status, problem, correlationId2) {
    super(status, problem, correlationId2);
    this.name = "AuthError";
  }
};
__name(_AuthError, "AuthError");
var AuthError = _AuthError;
var _RateLimitError = class _RateLimitError extends ApiError {
  constructor(problem, correlationId2) {
    super(429, problem, correlationId2);
    this.name = "RateLimitError";
  }
};
__name(_RateLimitError, "RateLimitError");
var RateLimitError = _RateLimitError;
var _NetworkError = class _NetworkError extends Error {
  constructor(cause) {
    super("Network request failed \u2014 is the gateway reachable?");
    this.name = "NetworkError";
    this.cause = cause;
  }
};
__name(_NetworkError, "NetworkError");
var NetworkError = _NetworkError;
function errorFromResponse(status, body, correlationId2) {
  const problem = body && typeof body === "object" ? body : { title: String(body ?? ""), status };
  if (status === 400 && problem.errors?.length) return new ValidationError(problem, correlationId2);
  if (status === 401 || status === 403) return new AuthError(status, problem, correlationId2);
  if (status === 429) return new RateLimitError(problem, correlationId2);
  return new ApiError(status, problem, correlationId2);
}
__name(errorFromResponse, "errorFromResponse");
function userMessage(error) {
  if (error instanceof ValidationError) {
    return error.fieldErrors[0]?.message ?? "Please check the highlighted fields.";
  }
  if (error instanceof RateLimitError) return "Too many requests \u2014 please wait a moment and try again.";
  if (error instanceof AuthError) {
    return error.status === 401 ? "Your session has expired. Please sign in again." : "You don't have permission to do that.";
  }
  if (error instanceof ApiError) {
    if (error.status === 404) return "We couldn't find what you were looking for.";
    if (error.status === 409) return error.problem.title ?? "That conflicts with the current state \u2014 please refresh and retry.";
    return error.problem.title ?? "Something went wrong. Please try again.";
  }
  if (error instanceof NetworkError) return "Connection problem \u2014 check your internet and try again.";
  return "Something went wrong. Please try again.";
}
__name(userMessage, "userMessage");

// src/api/tokenStore.ts
var STORAGE_KEY = "sv-tokens";
var REFRESH_SKEW_MS = 6e4;
var memory = null;
var listeners = /* @__PURE__ */ new Set();
function persist(tokens) {
  memory = tokens;
  if (typeof window !== "undefined") {
    try {
      if (tokens) window.localStorage.setItem(STORAGE_KEY, JSON.stringify(tokens));
      else window.localStorage.removeItem(STORAGE_KEY);
    } catch {
    }
  }
  listeners.forEach((l) => l(tokens));
}
__name(persist, "persist");
var tokenStore = {
  get() {
    if (memory) return memory;
    if (typeof window !== "undefined") {
      try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (raw) memory = JSON.parse(raw);
      } catch {
      }
    }
    return memory;
  },
  set(tokens) {
    persist(tokens);
  },
  clear() {
    persist(null);
  },
  /** True when an access token exists and is not inside the refresh window. */
  isAccessTokenFresh() {
    const tokens = tokenStore.get();
    if (!tokens) return false;
    return Date.parse(tokens.accessExpiresAt) - REFRESH_SKEW_MS > Date.now();
  },
  subscribe(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
  }
};

// src/api/http.ts
var authFailureListeners = /* @__PURE__ */ new Set();
function onAuthFailure(listener) {
  authFailureListeners.add(listener);
  return () => authFailureListeners.delete(listener);
}
__name(onAuthFailure, "onAuthFailure");
function correlationId() {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID().replace(/-/g, "");
  }
  return Math.random().toString(16).slice(2) + Date.now().toString(16);
}
__name(correlationId, "correlationId");
var refreshInFlight = null;
async function refreshTokens() {
  if (refreshInFlight) return refreshInFlight;
  const current = tokenStore.get();
  if (!current?.refreshToken) return null;
  refreshInFlight = (async () => {
    try {
      const response = await fetch(`${API_BASE_URL}${ROUTES.auth.refresh}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ refreshToken: current.refreshToken })
      });
      if (!response.ok) {
        tokenStore.clear();
        authFailureListeners.forEach((l) => l());
        return null;
      }
      const pair = await response.json();
      tokenStore.set(pair);
      return pair;
    } catch {
      return null;
    } finally {
      refreshInFlight = null;
    }
  })();
  return refreshInFlight;
}
__name(refreshTokens, "refreshTokens");
async function ensureFreshToken() {
  if (tokenStore.isAccessTokenFresh()) return tokenStore.get().accessToken;
  const refreshed = await refreshTokens();
  return refreshed?.accessToken ?? tokenStore.get()?.accessToken ?? null;
}
__name(ensureFreshToken, "ensureFreshToken");
var RETRYABLE_METHODS = /* @__PURE__ */ new Set(["GET", "HEAD"]);
var MAX_NETWORK_RETRIES = 2;
async function execute(method, path, body, options, attempt = 0) {
  const headers = {
    "X-Correlation-Id": correlationId(),
    ...options.headers
  };
  if (body !== void 0) headers["Content-Type"] = "application/json";
  if (options.idempotencyKey) headers["Idempotency-Key"] = options.idempotencyKey;
  if (!options.anonymous) {
    const token = options.accessToken ?? await ensureFreshToken();
    if (token) headers.Authorization = `Bearer ${token}`;
  }
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);
  options.signal?.addEventListener("abort", () => controller.abort(), { once: true });
  let response;
  try {
    response = await fetch(`${API_BASE_URL}${path}`, {
      method,
      headers,
      body: body !== void 0 ? JSON.stringify(body) : void 0,
      signal: controller.signal
    });
  } catch (cause) {
    if (RETRYABLE_METHODS.has(method) && attempt < MAX_NETWORK_RETRIES) {
      await new Promise((r) => setTimeout(r, 300 * 2 ** attempt));
      return execute(method, path, body, options, attempt + 1);
    }
    throw new NetworkError(cause);
  } finally {
    clearTimeout(timeout);
  }
  options.onHeaders?.(response.headers);
  if (response.status === 401 && !options.anonymous && attempt === 0) {
    const refreshed = await refreshTokens();
    if (refreshed) return execute(method, path, body, options, attempt + 1);
  }
  const corr = response.headers.get("X-Correlation-Id");
  if (!response.ok) {
    let problem = null;
    try {
      problem = await response.json();
    } catch {
    }
    const error = errorFromResponse(response.status, problem, corr);
    if (error instanceof AuthError && error.status === 401 && !options.anonymous) {
      tokenStore.clear();
      authFailureListeners.forEach((l) => l());
    }
    throw error;
  }
  if (response.status === 204) return void 0;
  const contentType = response.headers.get("content-type") ?? "";
  if (contentType.includes("json")) return await response.json();
  return await response.blob();
}
__name(execute, "execute");
var http = {
  get: /* @__PURE__ */ __name((path, options = {}) => execute("GET", path, void 0, options), "get"),
  post: /* @__PURE__ */ __name((path, body, options = {}) => execute("POST", path, body, options), "post"),
  put: /* @__PURE__ */ __name((path, body, options = {}) => execute("PUT", path, body, options), "put"),
  patch: /* @__PURE__ */ __name((path, body, options = {}) => execute("PATCH", path, body, options), "patch"),
  delete: /* @__PURE__ */ __name((path, options = {}) => execute("DELETE", path, void 0, options), "delete")
};

// src/api/jwt.ts
function base64UrlDecode(segment) {
  const padded = segment.replace(/-/g, "+").replace(/_/g, "/");
  if (typeof atob === "function") return decodeURIComponent(escape(atob(padded)));
  return Buffer.from(padded, "base64").toString("utf-8");
}
__name(base64UrlDecode, "base64UrlDecode");
function decodeUser(accessToken) {
  try {
    const [, payload] = accessToken.split(".");
    if (!payload) return null;
    const claims = JSON.parse(base64UrlDecode(payload));
    const rawRoles = claims["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"] ?? claims.role ?? [];
    const roles = (Array.isArray(rawRoles) ? rawRoles : [rawRoles]).map((r) => r.toLowerCase()).filter((r) => ["admin", "manager", "worker", "customer", "platform_admin"].includes(r));
    if (!claims.sub) return null;
    return {
      id: claims.sub,
      email: claims.email ?? "",
      name: claims.name ?? claims.email ?? "",
      roles,
      isPlatformAdmin: claims.is_platform_admin === "true"
    };
  } catch {
    return null;
  }
}
__name(decodeUser, "decodeUser");

// src/api/auth.ts
var authApi = {
  async login(body) {
    const pair = await http.post(ROUTES.auth.login, body, { anonymous: true });
    tokenStore.set(pair);
    return pair;
  },
  /** Exchanges a real Google ID token (obtained client-side via Firebase Auth) for a
   * ServiceVault token pair — POST /api/v1/auth/google, auto-provisions a customer account by
   * verified email if this is a first-time sign-in. 501s if the backend has no
   * Firebase__ProjectId / Google__ClientId configured. */
  async google(idToken) {
    const pair = await http.post(ROUTES.auth.google, { idToken }, { anonymous: true });
    tokenStore.set(pair);
    return pair;
  },
  /** Guest checkout — POST /api/v1/auth/guest creates a passwordless customer account for this
   * email and returns a normal token pair. 409 `email-taken` if the address already has any
   * account (the caller should send the user to sign in / reset their password instead). */
  async guest(email, name) {
    const pair = await http.post(ROUTES.auth.guest, { email, name }, { anonymous: true });
    tokenStore.set(pair);
    return pair;
  },
  me() {
    return http.get(ROUTES.auth.me);
  },
  /** What the signed-in user may do, per (module, action) of the permission matrix — same verdict the gateway applies. */
  myPermissions() {
    return http.get("/api/v1/auth/my-permissions");
  },
  async register(body) {
    return http.post(ROUTES.auth.register, body, { anonymous: true });
  },
  async refresh(refreshToken) {
    const pair = await http.post(ROUTES.auth.refresh, { refreshToken }, { anonymous: true });
    tokenStore.set(pair);
    return pair;
  },
  /** Local sign-out — the backend revokes refresh tokens on password reset / role change. */
  logout() {
    tokenStore.clear();
  },
  requestPasswordReset(email) {
    return http.post(ROUTES.auth.forgotPassword, { email }, { anonymous: true });
  },
  resetPassword(token, newPassword) {
    return http.post(ROUTES.auth.resetPassword, { token, newPassword }, { anonymous: true });
  },
  verifyEmail(token) {
    return http.post(ROUTES.auth.verifyEmail, { token }, { anonymous: true });
  },
  listRoles() {
    return http.get(ROUTES.auth.roles);
  },
  /** Staff seat count (admin/manager/worker) for the caller's own tenant — powers the
   * subscription usage bar. Manager+; deliberately separate from listUsers (admin-only PII). */
  async getUserCount() {
    const { count } = await http.get(ROUTES.auth.userCount);
    return count;
  },
  /** Platform admin only — sends (or re-sends, calling again for the same tenant/email is safe:
   * StoreInviteFlows.InviteStoreOwnerHandler has no pending-invite uniqueness check, only the
   * final Users-table email check, so an unused prior invite is simply superseded) a
   * store-owner invite for a tenant already created via tenantsApi.create. */
  inviteStoreOwner(tenantId, email, name) {
    return http.post(ROUTES.auth.inviteStoreOwner, { tenantId, email, name });
  },
  /** Anonymous — the invite token itself is the credential. Returns a real token pair, same as login. */
  async acceptStoreInvite(token, password) {
    const pair = await http.post(ROUTES.auth.acceptStoreInvite, { token, password }, { anonymous: true });
    tokenStore.set(pair);
    return pair;
  }
};

// src/api/users.ts
var usersApi = {
  list(role) {
    const q = role ? `?role=${encodeURIComponent(role)}` : "";
    return http.get(`${ROUTES.auth.users}${q}`);
  },
  get(id) {
    return http.get(`${ROUTES.auth.users}/${id}`);
  },
  update(id, body) {
    return http.put(`${ROUTES.auth.users}/${id}`, body);
  },
  remove(id) {
    return http.delete(`${ROUTES.auth.users}/${id}`);
  }
};

// src/api/booking.ts
var bookingApi = {
  async getCatalog() {
    const [areas, packages, items, roomTypes] = await Promise.all([
      http.get(ROUTES.catalog.serviceAreas, { anonymous: true }),
      http.get(ROUTES.catalog.packages, { anonymous: true }),
      http.get(ROUTES.catalog.items, { anonymous: true }),
      http.get(ROUTES.catalog.roomTypes, { anonymous: true })
    ]);
    return { areas, packages, items, roomTypes };
  },
  /** Dynamic quote. Pass promoCode to apply a campaign discount server-side. */
  createQuote(body) {
    return http.post(ROUTES.quotes, body, { anonymous: true });
  },
  getQuote(id) {
    return http.get(`${ROUTES.quotes}/${id}`);
  },
  /** Admin view — most recent 100 quotes. No update/delete: quotes are immutable price snapshots. */
  listQuotes() {
    return http.get(ROUTES.quotes);
  },
  createBooking(body, options = {}) {
    const key = options.idempotencyKey ?? cryptoKey();
    return http.post(ROUTES.bookings, body, { ...options, idempotencyKey: key });
  },
  getBooking(id, options) {
    return http.get(`${ROUTES.bookings}/${id}`, options);
  },
  /** Admin-wide list, newest first, cursor-paginated. Requires the manager role. */
  listBookings(filters = {}) {
    const params = new URLSearchParams();
    if (filters.status) params.set("status", filters.status);
    if (filters.serviceType) params.set("serviceType", filters.serviceType);
    if (filters.from) params.set("from", filters.from);
    if (filters.to) params.set("to", filters.to);
    if (filters.cursor) params.set("cursor", filters.cursor);
    if (filters.pageSize) params.set("pageSize", String(filters.pageSize));
    const qs = params.toString();
    return http.get(`${ROUTES.bookings}${qs ? `?${qs}` : ""}`);
  },
  /**
   * Cursor-paginated, same as `listBookings` — the type here was wrong until a live test
   * caught it (`bookings.filter is not a function`): the backend's `ByCustomer` action uses
   * the same `ToCursorPageAsync` helper as the admin-wide list, so it was never a bare array.
   */
  getCustomerBookings(customerId, params = {}, options) {
    const q = new URLSearchParams();
    if (params.cursor) q.set("cursor", params.cursor);
    if (params.pageSize) q.set("pageSize", String(params.pageSize));
    const qs = q.toString();
    return http.get(`${ROUTES.bookings}/by-customer/${customerId}${qs ? `?${qs}` : ""}`, options);
  },
  cancelBooking(id, reason, options) {
    return http.post(`${ROUTES.bookings}/${id}/cancel`, { reason }, options);
  },
  /** Cursor-paginated audit trail for one booking, newest first. */
  getBookingHistory(id, cursor, pageSize = 20) {
    const params = new URLSearchParams({ pageSize: String(pageSize) });
    if (cursor) params.set("cursor", cursor);
    return http.get(`${ROUTES.bookings}/${id}/history?${params.toString()}`);
  }
};
function cryptoKey() {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) return crypto.randomUUID();
  return `booking-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}
__name(cryptoKey, "cryptoKey");

// src/api/scheduling.ts
var schedulingApi = {
  getDay(date) {
    return http.get(`${ROUTES.schedule}?date=${encodeURIComponent(date)}`);
  },
  getCustomerJobs(customerId) {
    return http.get(`${ROUTES.schedule}/by-customer/${customerId}`);
  },
  optimize(date) {
    return http.post(`${ROUTES.schedule}/optimize`, { date });
  },
  assignWorker(jobId, workerId, assignedBy = "manual") {
    return http.post(`${ROUTES.schedule}/assignments`, { jobId, workerId, assignedBy });
  },
  reschedule(jobId, newStart, reason, initiatedByAi = false) {
    return http.post(`${ROUTES.jobs}/${jobId}/reschedule`, { newStart, reason, initiatedByAi });
  },
  /** Cancel a single visit without cancelling the rest of a recurring booking. */
  cancelJob(jobId, reason) {
    return http.post(`${ROUTES.jobs}/${jobId}/cancel`, { reason });
  },
  // ── Worker job-application flow (worker|manager at the gateway) ──
  /** Manager opts an unassigned job into the applicant pool. */
  openForApplications(jobId) {
    return http.post(`${ROUTES.schedule}/jobs/${jobId}/open-for-applications`, {});
  },
  /** Real, open jobs a worker can apply to. */
  availableJobs(filters) {
    const params = new URLSearchParams();
    if (filters?.service) params.set("service", filters.service);
    if (filters?.suburb) params.set("suburb", filters.suburb);
    const qs = params.toString();
    return http.get(`${ROUTES.schedule}/available-jobs${qs ? `?${qs}` : ""}`);
  },
  /** Applicants for a job — manager only. */
  applicantsFor(jobId) {
    return http.get(`${ROUTES.schedule}/jobs/${jobId}/applications`);
  },
  /** The signed-in worker's own application history. */
  myApplications() {
    return http.get(`${ROUTES.schedule}/my-applications`);
  },
  /** Worker applies to an open job. */
  applyToJob(jobId) {
    return http.post(`${ROUTES.schedule}/jobs/${jobId}/applications`, {});
  },
  /** Manager selects an applicant — performs the real assignment. */
  selectApplicant(jobId, applicationId) {
    return http.post(`${ROUTES.schedule}/jobs/${jobId}/applications/${applicationId}/select`, {});
  },
  /** Worker declines a job they were selected for — reopens it for other applicants. */
  declineAssignment(jobId) {
    return http.post(`${ROUTES.schedule}/jobs/${jobId}/decline`, {});
  }
};

// src/api/workers.ts
var workersApi = {
  /** `includeInactive` is for Module 3's admin oversight list — the default (false) preserves
   * existing dispatcher-tooling callers, who only ever want active workers. */
  list(includeInactive = false) {
    return http.get(`${ROUTES.workers}${includeInactive ? "?includeInactive=true" : ""}`);
  },
  /** Manager+ admin detail: profile + real job/earnings stats (Module 3). */
  adminDetail(workerId) {
    return http.get(`${ROUTES.workers}/${workerId}`);
  },
  /** Manager+: one worker's real job history (Module 3) — same shape as `myJobs`, scoped by an
   * explicit workerId instead of the caller's own resolved worker. */
  jobsFor(workerId, status = "upcoming") {
    return http.get(`${ROUTES.workers}/${workerId}/jobs?status=${status}`);
  },
  /** Manager+: deactivate/reactivate. History is kept — this only flips a flag. */
  setActive(workerId, active) {
    return http.put(`${ROUTES.workers}/${workerId}/active`, { active });
  },
  /** The signed-in worker's own profile. 404s if no Worker record is linked to this account yet. */
  me() {
    return http.get(`${ROUTES.workers}/me`);
  },
  /** Worker Dashboard Overview: upcoming/completed job counts, earnings, next jobs. */
  myDashboard() {
    return http.get(`${ROUTES.workers}/me/dashboard`);
  },
  /** "Booking Requests" reconciled to the dispatch model — see WorkerJobsPage. */
  myJobs(status = "upcoming") {
    return http.get(`${ROUTES.workers}/me/jobs?status=${status}`);
  },
  updateMe(body) {
    return http.put(`${ROUTES.workers}/me`, body);
  },
  /** Anonymous "Find Cleaners" search — no auth required. */
  publicSearch(params = {}) {
    const q = new URLSearchParams();
    if (params.service) q.set("service", params.service);
    if (params.areaCode) q.set("areaCode", params.areaCode);
    const qs = q.toString();
    return http.get(`${ROUTES.workers}/public/search${qs ? `?${qs}` : ""}`);
  },
  /** Customer-only: rate a completed job. 409s if that job was already rated. */
  submitRating(body) {
    return http.post(`${ROUTES.workers}/ratings`, body);
  },
  /** Anonymous — average/breakdown/reviews for one worker. */
  ratingsFor(workerId) {
    return http.get(`${ROUTES.workers}/public/${workerId}/ratings`);
  },
  create(body) {
    return http.post(ROUTES.workers, body);
  },
  nearby(lat, lng, radiusMeters = 5e3) {
    return http.get(`${ROUTES.workers}/nearby?lat=${lat}&lng=${lng}&radius=${radiusMeters}`);
  },
  /** Mobile "Today" screen: a worker's ordered stops for a date. */
  route(workerId, date) {
    return http.get(`${ROUTES.workers}/${workerId}/route?date=${encodeURIComponent(date)}`);
  },
  listShifts(workerId, from) {
    const q = from ? `?from=${encodeURIComponent(from)}` : "";
    return http.get(`${ROUTES.workers}/${workerId}/shifts${q}`);
  },
  createShift(workerId, body) {
    return http.post(`${ROUTES.workers}/${workerId}/shifts`, body);
  },
  startShift(shiftId) {
    return http.post(`${ROUTES.workers}/shifts/${shiftId}/start`);
  },
  completeShift(shiftId) {
    return http.post(`${ROUTES.workers}/shifts/${shiftId}/complete`);
  },
  cancelShift(shiftId) {
    return http.post(`${ROUTES.workers}/shifts/${shiftId}/cancel`);
  },
  checkIn(body) {
    return http.post(ROUTES.checkins, body);
  },
  checkOut(checkInId) {
    return http.post(`${ROUTES.checkins}/${checkInId}/checkout`);
  },
  myVerification() {
    return http.get(`${ROUTES.workers}/me/verification`);
  },
  /** multipart/form-data — bypasses the JSON `http` client, same as imagesApi.upload(). */
  async submitVerification(file) {
    const form = new FormData();
    form.append("file", file);
    const token = tokenStore.get()?.accessToken;
    const response = await fetch(`${API_BASE_URL}${ROUTES.workers}/me/verification`, {
      method: "POST",
      headers: token ? { Authorization: `Bearer ${token}` } : void 0,
      body: form
    });
    if (!response.ok) {
      const problem = await response.json().catch(() => null);
      throw errorFromResponse(response.status, problem, response.headers.get("X-Correlation-Id"));
    }
    return response.json();
  },
  /** Manager+: approve or reject a pending verification. */
  reviewVerification(workerId, body) {
    return http.put(`${ROUTES.workers}/${workerId}/verification`, body);
  },
  myPayouts() {
    return http.get(`${ROUTES.workers}/me/payouts`);
  },
  /** Manager+: one worker's payout history. */
  payoutsFor(workerId) {
    return http.get(`${ROUTES.workers}/${workerId}/payouts`);
  },
  /** Manager+: computes and snapshots a payout from real CheckIn durations in the period. */
  createPayout(workerId, periodStart, periodEnd) {
    return http.post(`${ROUTES.workers}/${workerId}/payouts`, { periodStart, periodEnd });
  },
  /** Manager+: marks a payout Paid, notifies the worker live. */
  releasePayout(payoutId) {
    return http.post(`${ROUTES.workers}/payouts/${payoutId}/release`);
  },
  /** Live workforce tracking (Prompt 2.4/8.1) — not persisted, just relayed to dispatchers via
   * WorkerHub's OnLocationUpdated. Call periodically while checked in. */
  pingLocation(latitude, longitude) {
    return http.post(`${ROUTES.workers}/me/location`, { latitude, longitude });
  }
};

// src/api/crm.ts
var crmApi = {
  listCustomers() {
    return http.get(ROUTES.customers);
  },
  getCustomer(id) {
    return http.get(`${ROUTES.customers}/${id}`);
  },
  upsertCustomer(body, options) {
    return http.post(ROUTES.customers, body, options);
  },
  /**
   * The signed-in user's own CRM customer record — resolves/auto-provisions it from the
   * JWT (by UserId, then by verified email, then creates one). Call this once after login
   * to get the customerId "My Bookings" and the profile page are keyed on.
   *
   * `options` matters most for server-side callers (see RequestOptions.accessToken) —
   * there's no tokenStore/localStorage in a Next.js server action.
   */
  async getMe(options) {
    const res = await http.get(`${ROUTES.customers}/me`, options);
    return {
      id: res.customerId,
      userId: res.userId,
      name: res.name,
      email: res.email,
      phone: res.phone,
      addressLine: res.addressLine,
      suburb: res.suburb,
      city: res.city,
      preferredContactMethod: res.preferredContactMethod,
      preferredTime: res.preferredTime,
      rowVersion: res.rowVersion,
      provisioned: res.provisioned
    };
  },
  updatePreferences(customerId, prefs) {
    return http.put(`${ROUTES.customers}/${customerId}/preferences`, prefs);
  },
  /** Customer-360: CRM fans out to Booking/Scheduling/Billing (Pattern 1). */
  getCustomer360(customerId) {
    return http.get(`${ROUTES.customers}/${customerId}/dashboard`);
  },
  removeCustomer(id) {
    return http.delete(`${ROUTES.customers}/${id}`);
  },
  // ── CMS ──
  getPublicPage(page) {
    return http.get(ROUTES.cms.public(page), { anonymous: true });
  },
  /** Anonymous — block visibility/order for a page (see CmsLayoutEntry). */
  getPublicLayout(page) {
    return http.get(`${ROUTES.cms.public(page)}/layout`, { anonymous: true });
  },
  /** Manager — create the default block rows a page is missing so every storefront block is listed (idempotent). */
  ensureBlocks(page) {
    return http.post(`/api/v1/cms/blocks/ensure?page=${encodeURIComponent(page)}`, void 0);
  },
  listSections(page) {
    const q = page ? `?page=${encodeURIComponent(page)}` : "";
    return http.get(`${ROUTES.cms.sections}${q}`);
  },
  createSection(body) {
    return http.post(ROUTES.cms.sections, body);
  },
  updateSection(id, body) {
    return http.put(`${ROUTES.cms.sections}/${id}`, body);
  },
  removeSection(id) {
    return http.delete(`${ROUTES.cms.sections}/${id}`);
  }
};

// src/api/billing.ts
var billingApi = {
  getInvoices(customerId) {
    const q = customerId ? `?customerId=${customerId}` : "";
    return http.get(`${ROUTES.invoices}${q}`);
  },
  recordCashPayment(invoiceId) {
    return http.post(`${ROUTES.payments}/cash`, { invoiceId });
  },
  /** Human-only refund — the AI can only *propose* refunds (backend enforces this). */
  refund(paymentId, reason) {
    return http.post(`${ROUTES.payments}/${paymentId}/refund`, { reason });
  },
  /** customer,manager — creates/reuses a Pending Payment row keyed by orderId, returns the
   * Stripe PaymentIntent's clientSecret for the frontend's Stripe Elements form. */
  createPaymentIntent(body) {
    return http.post(ROUTES.paymentIntent, body);
  },
  /** manager+ — order-scoped refund (as opposed to refund() above, which is paymentId-scoped);
   * omitting amount does a full refund. */
  refundOrderPayment(body) {
    return http.post(ROUTES.paymentRefund, body);
  },
  getAccountingSummary(from, to) {
    return http.get(`${ROUTES.accounting}/summary?from=${from}&to=${to}`);
  },
  /** CSV export — bypasses the JSON client so we get the raw Blob with auth. */
  async exportCsv(from, to) {
    const token = tokenStore.get()?.accessToken;
    const response = await fetch(`${API_BASE_URL}${ROUTES.accounting}/export.csv?from=${from}&to=${to}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    });
    if (!response.ok) throw new Error(`Export failed (${response.status})`);
    return response.blob();
  }
};

// src/api/reports.ts
var reportsApi = {
  generate(body) {
    return http.post(ROUTES.reports.generate, body);
  },
  list() {
    return http.get(ROUTES.reports.list);
  },
  get(id) {
    return http.get(ROUTES.reports.get(id));
  },
  delete(id) {
    return http.delete(ROUTES.reports.delete(id));
  },
  /** Bypasses the JSON client for the raw Blob with auth — same pattern as billingApi.exportCsv. */
  async download(id) {
    const token = tokenStore.get()?.accessToken;
    const response = await fetch(`${API_BASE_URL}${ROUTES.reports.download(id)}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    });
    if (!response.ok) throw new Error(`Download failed (${response.status})`);
    return response.blob();
  },
  listSchedules() {
    return http.get(ROUTES.reports.schedules);
  },
  createSchedule(body) {
    return http.post(ROUTES.reports.schedules, body);
  },
  updateSchedule(id, body) {
    return http.put(ROUTES.reports.schedule(id), body);
  },
  deleteSchedule(id) {
    return http.delete(ROUTES.reports.schedule(id));
  }
};

// src/api/analytics.ts
var analyticsApi = {
  revenue(from, to) {
    return http.get(`${ROUTES.analytics}/revenue?from=${from}&to=${to}`);
  },
  jobs(from, to) {
    return http.get(`${ROUTES.analytics}/jobs?from=${from}&to=${to}`);
  },
  workers(from, to) {
    return http.get(`${ROUTES.analytics}/workers?from=${from}&to=${to}`);
  },
  demand(from, to) {
    return http.get(`${ROUTES.analytics}/demand?from=${from}&to=${to}`);
  }
};

// src/api/ai.ts
var aiApi = {
  sendMessage(message, sessionId) {
    return http.post(ROUTES.ai.chat, { message, sessionId }, { anonymous: true });
  },
  getSession(sessionId) {
    return http.get(ROUTES.ai.chatSession(sessionId), { anonymous: true });
  },
  /** Idempotent — embeds the SOP/policy corpus if not already present. */
  seedCorpus() {
    return http.post(ROUTES.ai.chatSeed, void 0, { anonymous: true });
  },
  /** Rule-based "same category, most recently added" — anonymous storefront feature,
   * same tier as chat (see ai-engine/app/routers/commerce.py's module docstring). */
  getRecommendations(productId, limit = 5) {
    return http.get(ROUTES.ai.recommendations(productId, limit), { anonymous: true });
  },
  /** manager+ — real per-feature usage counters (chat/commerce/agent/automation/MCP tools),
   * see ai-engine/app/routers/verification.py. Not anonymous: auth token is attached
   * automatically by http.ts from tokenStore. */
  getUsageStats() {
    return http.get(ROUTES.ai.usageStats);
  },
  /** manager+ — recent, PII-redacted audit log entries for one tenant. */
  getAuditLogs(limit = 50) {
    return http.get(ROUTES.ai.auditLogs(limit));
  },
  /** Real tool-calling shopping agent (LangGraph ReAct over ai-engine's own MCP tools) —
   * anonymous, same tier as sendMessage. */
  agentChat(message, sessionId) {
    return http.post(ROUTES.ai.agentChat, { message, session_id: sessionId }, { anonymous: true });
  },
  /** manager+ — real analytics agent (get_sales_summary/get_order_funnel/
   * get_retention_cohorts MCP tools). Not anonymous: auth token attached automatically. */
  analyticsAgentChat(message, sessionId) {
    return http.post(ROUTES.ai.analyticsAgentChat, { message, session_id: sessionId });
  },
  /** manager+ — real support agent (get_order_status/ask_store/search_knowledge MCP tools). */
  supportAgentChat(message, sessionId) {
    return http.post(ROUTES.ai.supportAgentChat, { message, session_id: sessionId });
  }
};

// src/api/notifications.ts
var notificationsApi = {
  listForUser(customerId, cursor, pageSize = 20) {
    const params = new URLSearchParams({ pageSize: String(pageSize) });
    if (cursor) params.set("cursor", cursor);
    return http.get(`${ROUTES.notifications}/user/${customerId}?${params.toString()}`);
  },
  /** Manager+ only — the store team's own notifications + unread count (admin bell). */
  listStaff(limit = 30) {
    return http.get(`${ROUTES.notifications}/staff?limit=${limit}`);
  },
  readAllStaff() {
    return http.put(`${ROUTES.notifications}/staff/read-all`, void 0);
  },
  markRead(id) {
    return http.put(`${ROUTES.notifications}/${id}/read`, void 0);
  },
  /** Manager+ only — every customer's send log, not just one. */
  listAll(filters = {}) {
    const params = new URLSearchParams();
    if (filters.status) params.set("status", filters.status);
    if (filters.channel) params.set("channel", filters.channel);
    if (filters.cursor) params.set("cursor", filters.cursor);
    if (filters.pageSize) params.set("pageSize", String(filters.pageSize));
    const qs = params.toString();
    return http.get(`${ROUTES.notifications}${qs ? `?${qs}` : ""}`);
  },
  /** Manager+ only — send a real template to an arbitrary inbox to preview it end-to-end. */
  testSend(body) {
    return http.post(`${ROUTES.notifications}/test-send`, body);
  }
};

// src/api/catalogAdmin.ts
var catalogAdminApi = {
  listAreas() {
    return http.get(`${ROUTES.catalogAdmin}/service-areas`);
  },
  createArea(body) {
    return http.post(`${ROUTES.catalogAdmin}/service-areas`, body);
  },
  updateArea(id, body) {
    return http.put(`${ROUTES.catalogAdmin}/service-areas/${id}`, body);
  },
  deleteArea(id) {
    return http.delete(`${ROUTES.catalogAdmin}/service-areas/${id}`);
  },
  createPackage(body) {
    return http.post(`${ROUTES.catalogAdmin}/packages`, body);
  },
  updatePackage(id, body) {
    return http.put(`${ROUTES.catalogAdmin}/packages/${id}`, body);
  },
  deletePackage(id) {
    return http.delete(`${ROUTES.catalogAdmin}/packages/${id}`);
  },
  listItems() {
    return http.get(`${ROUTES.catalogAdmin}/items`);
  },
  createItem(body) {
    return http.post(`${ROUTES.catalogAdmin}/items`, body);
  },
  updateItem(id, body) {
    return http.put(`${ROUTES.catalogAdmin}/items/${id}`, body);
  },
  deleteItem(id) {
    return http.delete(`${ROUTES.catalogAdmin}/items/${id}`);
  }
};

// src/api/campaigns.ts
var campaignsApi = {
  list() {
    return http.get(ROUTES.campaigns);
  },
  get(id) {
    return http.get(`${ROUTES.campaigns}/${id}`);
  },
  create(body) {
    return http.post(ROUTES.campaigns, body);
  },
  update(id, body) {
    return http.put(`${ROUTES.campaigns}/${id}`, body);
  },
  remove(id) {
    return http.delete(`${ROUTES.campaigns}/${id}`);
  }
};

// src/api/testimonials.ts
var testimonialsApi = {
  list() {
    return http.get(ROUTES.testimonials.base);
  },
  /** Published testimonials in display order. `featured: true` returns only the home-page selection. */
  getPublic(featured) {
    const q = featured ? "?featured=true" : "";
    return http.get(`${ROUTES.testimonials.public}${q}`, { anonymous: true });
  },
  create(body) {
    return http.post(ROUTES.testimonials.base, body);
  },
  update(id, body) {
    return http.put(`${ROUTES.testimonials.base}/${id}`, body);
  },
  remove(id) {
    return http.delete(`${ROUTES.testimonials.base}/${id}`);
  }
};

// src/api/subscriptions.ts
var subscriptionsApi = {
  listPlans(includeInactive = false) {
    const q = includeInactive ? "?includeInactive=true" : "";
    return http.get(`${ROUTES.subscriptions.plans}${q}`);
  },
  createPlan(body) {
    return http.post(ROUTES.subscriptions.plans, body);
  },
  updatePlan(id, body) {
    return http.put(`${ROUTES.subscriptions.plans}/${id}`, body);
  },
  deletePlan(id) {
    return http.delete(`${ROUTES.subscriptions.plans}/${id}`);
  },
  /** The calling tenant's current subscription, or null if never assigned one. */
  async getMySubscription() {
    try {
      return await http.get(ROUTES.subscriptions.tenant);
    } catch (err) {
      if (err?.status === 404) return null;
      throw err;
    }
  },
  upgrade(planId, billingCycle) {
    return http.post(ROUTES.subscriptions.tenantUpgrade, { planId, billingCycle });
  },
  cancel() {
    return http.post(ROUTES.subscriptions.tenantCancel, {});
  },
  /** Real Stripe Checkout Session — returns the hosted-page URL to redirect to. */
  createCheckout(planId, billingCycle) {
    return http.post(ROUTES.subscriptions.tenantCheckout, { planId, billingCycle });
  },
  /** Real Stripe Customer Portal — returns the hosted-page URL; 409s if the tenant has never checked out via Stripe. */
  createPortalSession() {
    return http.post(ROUTES.subscriptions.tenantPortal, {});
  },
  listAllTenantSubscriptions() {
    return http.get(ROUTES.subscriptions.allTenants);
  },
  getDashboard() {
    return http.get(ROUTES.subscriptions.dashboard);
  },
  /** Set or clear a tenant's discount — pass discountCode: null to clear. */
  setDiscount(tenantId, discountCode, discountPercent) {
    return http.put(ROUTES.subscriptions.tenantDiscount(tenantId), { discountCode, discountPercent });
  },
  /** Manual paper-trail refund flag — no real charge reversal (no payment processor wired to subscriptions). */
  markRefunded(tenantId, reason) {
    return http.post(ROUTES.subscriptions.tenantRefund(tenantId), { reason });
  },
  /** Replaces this tenant's full feature-override set (on top of whatever its plan already grants). */
  setFeatureOverrides(tenantId, features) {
    return http.put(ROUTES.subscriptions.tenantFeatures(tenantId), { features });
  },
  getMrrTrend() {
    return http.get(ROUTES.subscriptions.analyticsMrr);
  },
  getChurnTrend() {
    return http.get(ROUTES.subscriptions.analyticsChurn);
  },
  getPlanDistribution() {
    return http.get(ROUTES.subscriptions.analyticsDistribution);
  },
  /** CSV export — bypasses the JSON client so we get the raw Blob with auth (mirrors billingApi.exportCsv). */
  async exportTenantsCsv() {
    const token = tokenStore.get()?.accessToken;
    const response = await fetch(`${API_BASE_URL}${ROUTES.subscriptions.tenantsExportCsv}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    });
    if (!response.ok) throw new Error(`Export failed (${response.status})`);
    return response.blob();
  },
  async exportMrrCsv() {
    const token = tokenStore.get()?.accessToken;
    const response = await fetch(`${API_BASE_URL}${ROUTES.subscriptions.analyticsMrrExportCsv}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    });
    if (!response.ok) throw new Error(`Export failed (${response.status})`);
    return response.blob();
  }
};

// src/api/tenants.ts
var tenantsApi = {
  list() {
    return http.get(ROUTES.tenants.base);
  },
  get(id) {
    return http.get(`${ROUTES.tenants.base}/${id}`);
  },
  create(body) {
    return http.post(ROUTES.tenants.base, body);
  },
  update(id, body) {
    return http.put(`${ROUTES.tenants.base}/${id}`, body);
  },
  /** Deactivate, not delete — a tenant id is referenced by rows in every other service's
   * database (see TenantsController.Deactivate's own doc comment). */
  deactivate(id) {
    return http.post(ROUTES.tenants.deactivate(id), {});
  }
};

// src/api/discounts.ts
var discountsApi = {
  listRules() {
    return http.get(ROUTES.discounts.rules);
  },
  createRule(body) {
    return http.post(ROUTES.discounts.rules, body);
  },
  updateRule(id, body) {
    return http.put(`${ROUTES.discounts.rules}/${id}`, body);
  },
  removeRule(id) {
    return http.delete(`${ROUTES.discounts.rules}/${id}`);
  },
  ruleAnalytics(id) {
    return http.get(ROUTES.discounts.ruleAnalytics(id));
  },
  /** Anonymous — early feedback only (code exists + is currently running), not a discount amount. */
  validate(code) {
    return http.get(ROUTES.discounts.validate(code), { anonymous: true });
  },
  /** Read-only preview of the best-matching discount for a cart — same calculation OrderService
   * runs authoritatively at checkout, called here just so the cart page can show it in advance. */
  calculate(body) {
    return http.post(ROUTES.discounts.calculate, body);
  }
};

// src/api/locations.ts
var locationsApi = {
  /** Locations ARE cities — ?regionId= narrows to one Region (the hierarchy's "cities" level),
   * omit it for the full flat list. */
  list(includeInactive = false, regionId) {
    const params = new URLSearchParams();
    if (includeInactive) params.set("includeInactive", "true");
    if (regionId) params.set("regionId", regionId);
    const qs = params.toString();
    return http.get(`${ROUTES.locations.base}${qs ? `?${qs}` : ""}`, { anonymous: true });
  },
  listCountries() {
    return http.get(ROUTES.locations.countries, { anonymous: true });
  },
  listRegions(countryId) {
    const qs = countryId ? `?countryId=${countryId}` : "";
    return http.get(`${ROUTES.locations.regions}${qs}`, { anonymous: true });
  },
  listSuburbs(locationId) {
    return http.get(ROUTES.locations.suburbs(locationId), { anonymous: true });
  },
  createSuburb(locationId, body) {
    return http.post(ROUTES.locations.suburbs(locationId), body);
  },
  removeSuburb(locationId, suburbId) {
    return http.delete(`${ROUTES.locations.suburbs(locationId)}/${suburbId}`);
  },
  create(body) {
    return http.post(ROUTES.locations.base, body);
  },
  update(id, body) {
    return http.put(`${ROUTES.locations.base}/${id}`, body);
  },
  remove(id) {
    return http.delete(`${ROUTES.locations.base}/${id}`);
  },
  copyTo(id, targetId) {
    return http.post(ROUTES.locations.copyTo(id, targetId), {});
  },
  getProductPricing(productId) {
    return http.get(ROUTES.locations.productPricing(productId));
  },
  setProductPricing(productId, body) {
    return http.put(ROUTES.locations.productPricing(productId), body);
  },
  bulkPricing(body) {
    return http.put(ROUTES.locations.bulkPricing, body);
  }
};

// src/api/blog.ts
var blogApi = {
  /** Authoring view — includes unpublished drafts, no pagination (server returns everything). */
  list() {
    return http.get(ROUTES.blog.base);
  },
  /** Anonymous: published posts, newest first, excerpt only — the storefront blog listing. */
  getPublic(params = {}) {
    const qs = new URLSearchParams();
    if (params.category) qs.set("category", params.category);
    if (params.page) qs.set("page", String(params.page));
    if (params.pageSize) qs.set("pageSize", String(params.pageSize));
    const query = qs.toString();
    return http.get(`${ROUTES.blog.public}${query ? `?${query}` : ""}`, { anonymous: true });
  },
  /** Anonymous: one published post by slug, with full body — the storefront blog detail page. */
  getPublicBySlug(slug) {
    return http.get(`${ROUTES.blog.public}/${encodeURIComponent(slug)}`, { anonymous: true });
  },
  get(id) {
    return http.get(`${ROUTES.blog.base}/${id}`);
  },
  create(body) {
    return http.post(ROUTES.blog.base, body);
  },
  update(id, body) {
    return http.put(`${ROUTES.blog.base}/${id}`, body);
  },
  remove(id) {
    return http.delete(`${ROUTES.blog.base}/${id}`);
  },
  /** Distinct categories among published posts — anonymous. */
  categories() {
    return http.get(ROUTES.blog.categories, { anonymous: true });
  }
};

// src/api/site.ts
var siteApi = {
  get() {
    return http.get(ROUTES.site.base);
  },
  getPublic() {
    return http.get(ROUTES.site.public, { anonymous: true });
  },
  /** Upsert — a tenant has exactly one site config. Returns {id} on first write, nothing after. */
  update(body) {
    return http.put(ROUTES.site.base, body);
  }
};

// src/api/images.ts
var imagesApi = {
  /** multipart/form-data — bypasses the JSON `http` client, which always sends JSON. */
  async upload(file, category) {
    const form = new FormData();
    form.append("file", file);
    if (category) form.append("category", category);
    const response = await sendMultipart(`${ROUTES.images.base}`, form);
    if (!response.ok) {
      const problem = await response.json().catch(() => null);
      throw errorFromResponse(response.status, problem, response.headers.get("X-Correlation-Id"));
    }
    return response.json();
  },
  list(category) {
    const q = category ? `?category=${encodeURIComponent(category)}` : "";
    return http.get(`${ROUTES.images.admin}${q}`);
  },
  /** Same upload as `upload()`, but over XHR so real byte-level progress can be reported —
   * `fetch` has no upload-progress event. Used by avatar/hero-image pickers that show a bar. */
  async uploadWithProgress(file, category, onProgress) {
    const form = new FormData();
    form.append("file", file);
    if (category) form.append("category", category);
    return sendXhr(`${ROUTES.images.base}`, form, onProgress);
  },
  /** No replace endpoint exists server-side — callers delete then upload(). */
  remove(fileName) {
    return http.delete(`${ROUTES.images.base}/${fileName}`);
  }
};
async function sendMultipart(path, form, attempt = 0) {
  const token = attempt === 0 ? await ensureFreshToken() : (await refreshTokens())?.accessToken;
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method: "POST",
    headers: token ? { Authorization: `Bearer ${token}` } : void 0,
    body: form
  });
  if (response.status === 401 && attempt === 0) return sendMultipart(path, form, attempt + 1);
  return response;
}
__name(sendMultipart, "sendMultipart");
async function sendXhr(path, form, onProgress, attempt = 0) {
  const token = attempt === 0 ? await ensureFreshToken() : (await refreshTokens())?.accessToken;
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", `${API_BASE_URL}${path}`);
    if (token) xhr.setRequestHeader("Authorization", `Bearer ${token}`);
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable) onProgress(Math.round(e.loaded / e.total * 100));
    };
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          resolve(JSON.parse(xhr.responseText));
        } catch {
          reject(new Error("Upload succeeded but the response could not be read."));
        }
      } else if (xhr.status === 401 && attempt === 0) {
        sendXhr(path, form, onProgress, attempt + 1).then(resolve, reject);
      } else {
        let problem = null;
        try {
          problem = JSON.parse(xhr.responseText);
        } catch {
        }
        reject(errorFromResponse(xhr.status, problem, xhr.getResponseHeader("X-Correlation-Id")));
      }
    };
    xhr.onerror = () => reject(new Error("Upload failed. Please check your connection."));
    xhr.send(form);
  });
}
__name(sendXhr, "sendXhr");

// src/api/contacts.ts
var contactsApi = {
  /** Anonymous — the customer-facing contact form. No auth header sent. */
  submitPublic(payload) {
    return http.post(`${ROUTES.contacts}/public`, payload, { anonymous: true });
  },
  list(status, cursor, pageSize = 50) {
    const params = new URLSearchParams({ pageSize: String(pageSize) });
    if (status) params.set("status", status);
    if (cursor) params.set("cursor", cursor);
    return http.get(`${ROUTES.contacts}?${params.toString()}`);
  },
  get(id) {
    return http.get(`${ROUTES.contacts}/${id}`);
  },
  /** rowVersion enables optimistic concurrency — a stale value 409s instead of clobbering. */
  setStatus(id, status, rowVersion) {
    return http.put(`${ROUTES.contacts}/${id}/status`, { status, rowVersion });
  },
  remove(id) {
    return http.delete(`${ROUTES.contacts}/${id}`);
  }
};

// src/api/messages.ts
var messagesApi = {
  inbox() {
    return http.get(ROUTES.messages);
  },
  history(conversationId, before) {
    const q = before ? `?before=${encodeURIComponent(before)}` : "";
    return http.get(`${ROUTES.messages}/${conversationId}${q}`);
  },
  send(body) {
    return http.post(ROUTES.messages, body);
  },
  markRead(conversationId) {
    return http.post(`${ROUTES.messages}/${conversationId}/read`);
  },
  /** Manager/admin only (RequireRoles enforced in CrmService) — asks ai-engine's real RAG
   * chat for a draft reply to the customer's latest message, grounded in the seeded
   * product/CMS/site corpus. `suggestion` is null when there's no customer message yet or
   * ai-engine is unreachable/blocked the request — `reason` explains which. Never sent
   * automatically; the caller must review/edit and send via `send()` above. */
  suggestReply(conversationId) {
    return http.get(`${ROUTES.messages}/${conversationId}/suggest-reply`);
  }
};

// src/api/jobPostings.ts
var jobPostingsApi = {
  create(body, options) {
    return http.post(ROUTES.jobPostings, body, options);
  },
  get(id, options) {
    return http.get(`${ROUTES.jobPostings}/${id}`, options);
  },
  /** Workers matching this posting's area+skill, computed fresh on every call. */
  matches(id, options) {
    return http.get(`${ROUTES.jobPostings}/${id}/matches`, options);
  }
};

// src/api/media.ts
var mediaApi = {
  async upload(file, jobId, phase = "Other", roomTag) {
    const form = new FormData();
    form.append("file", file);
    form.append("jobId", jobId);
    form.append("phase", phase);
    if (roomTag) form.append("roomTag", roomTag);
    const token = tokenStore.get()?.accessToken;
    const response = await fetch(`${API_BASE_URL}${ROUTES.media}/upload`, {
      method: "POST",
      headers: token ? { Authorization: `Bearer ${token}` } : void 0,
      body: form
    });
    if (!response.ok) {
      const problem = await response.json().catch(() => null);
      throw errorFromResponse(response.status, problem, response.headers.get("X-Correlation-Id"));
    }
    return response.json();
  },
  listForJob(jobId) {
    return http.get(`${ROUTES.media}/job/${jobId}`);
  },
  /** Fetches the actual bytes with the Bearer token attached — a plain `<img src>` can't carry
   * it, since this route isn't cookie-authenticated. Caller turns the Blob into an object URL. */
  async fetchFile(mediaId) {
    const token = tokenStore.get()?.accessToken;
    const response = await fetch(`${API_BASE_URL}${ROUTES.media}/${mediaId}/file`, {
      headers: token ? { Authorization: `Bearer ${token}` } : void 0
    });
    if (!response.ok) {
      const problem = await response.json().catch(() => null);
      throw errorFromResponse(response.status, problem, response.headers.get("X-Correlation-Id"));
    }
    return response.blob();
  }
};

// src/api/products.ts
var productsApi = {
  list(filters = {}) {
    const params = new URLSearchParams();
    if (filters.categoryId) params.set("categoryId", filters.categoryId);
    if (filters.status) params.set("status", filters.status);
    if (filters.search) params.set("search", filters.search);
    if (filters.featured !== void 0) params.set("featured", String(filters.featured));
    if (filters.brand) params.set("brand", filters.brand);
    if (filters.cursor) params.set("cursor", filters.cursor);
    if (filters.pageSize) params.set("pageSize", String(filters.pageSize));
    const qs = params.toString();
    return http.get(`${ROUTES.products}${qs ? `?${qs}` : ""}`, { anonymous: true });
  },
  get(id) {
    return http.get(`${ROUTES.products}/${id}`, { anonymous: true });
  },
  /** Distinct brands of published products with counts — GET /products/brands (anonymous). */
  brands() {
    return http.get(`${ROUTES.products}/brands`, { anonymous: true });
  },
  /** Header/typeahead suggestions — small top-N product + category matches. */
  search(q, limit = 8) {
    return http.get(`${ROUTES.products}/search?q=${encodeURIComponent(q)}&limit=${limit}`, { anonymous: true });
  },
  create(body) {
    return http.post(ROUTES.products, body);
  },
  /** RowVersion must be the value last read via get() — stale value 409s (optimistic concurrency). */
  update(id, body) {
    return http.put(`${ROUTES.products}/${id}`, body);
  },
  /** Quick enable/disable from a table row — changes ONLY the status (a full update would need the whole product). */
  setStatus(id, status) {
    return http.patch(`${ROUTES.products}/${id}/status`, { status });
  },
  remove(id) {
    return http.delete(`${ROUTES.products}/${id}`);
  },
  adjustInventory(id, body) {
    return http.patch(`${ROUTES.products}/${id}/inventory`, body);
  },
  /** Append-only stock ledger for one product, newest first, cursor-paginated. */
  getInventoryHistory(id, cursor, pageSize = 20) {
    const params = new URLSearchParams({ pageSize: String(pageSize) });
    if (cursor) params.set("cursor", cursor);
    return http.get(`${ROUTES.products}/${id}/inventory/history?${params.toString()}`);
  },
  /** `includeInactive`: admin management page passes true to see disabled categories too
   * (to re-enable them); the public storefront default (false) hides them from navigation. */
  listCategories(parentId, includeInactive = false) {
    const params = new URLSearchParams();
    if (parentId) params.set("parentId", parentId);
    if (includeInactive) params.set("includeInactive", "true");
    const qs = params.toString();
    return http.get(`${ROUTES.categories}${qs ? `?${qs}` : ""}`, { anonymous: true });
  },
  getCategory(id) {
    return http.get(`${ROUTES.categories}/${id}`, { anonymous: true });
  },
  createCategory(body) {
    return http.post(ROUTES.categories, body);
  },
  toggleCategory(id) {
    return http.put(`${ROUTES.categories}/${id}/toggle`, {});
  },
  /** Sends every category's id in its new display order — SortOrder becomes its index. */
  reorderCategories(orderedIds) {
    return http.put(`${ROUTES.categories}/reorder`, { orderedIds });
  },
  updateCategory(id, body) {
    return http.put(`${ROUTES.categories}/${id}`, body);
  },
  removeCategory(id) {
    return http.delete(`${ROUTES.categories}/${id}`);
  },
  /** Homepage hero carousel. `activeOnly` defaults true storefront-side; admin passes false
   * to manage the full set including drafts. */
  listHeroSlides(activeOnly = true) {
    return http.get(`${ROUTES.heroSlides}?activeOnly=${activeOnly}`, { anonymous: true });
  },
  createHeroSlide(body) {
    return http.post(ROUTES.heroSlides, body);
  },
  updateHeroSlide(id, body) {
    return http.put(`${ROUTES.heroSlides}/${id}`, body);
  },
  removeHeroSlide(id) {
    return http.delete(`${ROUTES.heroSlides}/${id}`);
  },
  /** Homepage promo-tile grid. `activeOnly` defaults true storefront-side; admin passes
   * false to manage the full set including drafts. */
  listPromoTiles(activeOnly = true) {
    return http.get(`${ROUTES.promoTiles}?activeOnly=${activeOnly}`, { anonymous: true });
  },
  createPromoTile(body) {
    return http.post(ROUTES.promoTiles, body);
  },
  updatePromoTile(id, body) {
    return http.put(`${ROUTES.promoTiles}/${id}`, body);
  },
  removePromoTile(id) {
    return http.delete(`${ROUTES.promoTiles}/${id}`);
  },
  /** Homepage campaign carousel (limited sales / festive offers). `runningOnly` defaults true
   * storefront-side; admin passes false to manage scheduled/expired/paused campaigns too. */
  listCampaigns(runningOnly = true) {
    return http.get(`${ROUTES.productCampaigns}?runningOnly=${runningOnly}`, { anonymous: true });
  },
  getCampaign(id) {
    return http.get(`${ROUTES.productCampaigns}/${id}`, { anonymous: true });
  },
  /** Every currently-running, homepage-enabled campaign, ordered for direct rendering —
   * the ecommerce homepage groups these by `section` client-side. */
  getHomepageCampaigns() {
    return http.get(`${ROUTES.productCampaigns}/homepage`, { anonymous: true });
  },
  createCampaign(body) {
    return http.post(ROUTES.productCampaigns, body);
  },
  updateCampaign(id, body) {
    return http.put(`${ROUTES.productCampaigns}/${id}`, body);
  },
  removeCampaign(id) {
    return http.delete(`${ROUTES.productCampaigns}/${id}`);
  }
};

// src/api/productMedia.ts
async function send(path, init, attempt = 0) {
  const token = attempt === 0 ? await ensureFreshToken() : (await refreshTokens())?.accessToken;
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...init,
    headers: token ? { ...init.headers, Authorization: `Bearer ${token}` } : init.headers
  });
  if (response.status === 401 && attempt === 0) return send(path, init, attempt + 1);
  return response;
}
__name(send, "send");
async function uploadMultipart(path, file) {
  const form = new FormData();
  form.append("file", file);
  const response = await send(path, { method: "POST", body: form });
  if (!response.ok) {
    const problem = await response.json().catch(() => null);
    throw errorFromResponse(response.status, problem, response.headers.get("X-Correlation-Id"));
  }
  return response.json();
}
__name(uploadMultipart, "uploadMultipart");
async function deleteWithAuth(path) {
  const response = await send(path, { method: "DELETE" });
  if (!response.ok && response.status !== 204) {
    const problem = await response.json().catch(() => null);
    throw errorFromResponse(response.status, problem, response.headers.get("X-Correlation-Id"));
  }
}
__name(deleteWithAuth, "deleteWithAuth");
var productMediaApi = {
  uploadProductImage(productId, file) {
    return uploadMultipart(`${ROUTES.productMedia}/products/${productId}/images`, file);
  },
  uploadProductVideo(productId, file) {
    return uploadMultipart(`${ROUTES.productMedia}/products/${productId}/videos`, file);
  },
  removeProductImage(productId, imageId) {
    return deleteWithAuth(`${ROUTES.productMedia}/products/${productId}/images/${imageId}`);
  },
  removeProductVideo(productId, videoId) {
    return deleteWithAuth(`${ROUTES.productMedia}/products/${productId}/videos/${videoId}`);
  },
  async uploadHeroSlideImage(file) {
    return (await uploadMultipart(`${ROUTES.productMedia}/hero-slides/image`, file)).url;
  },
  async uploadHeroSlideVideo(file) {
    return (await uploadMultipart(`${ROUTES.productMedia}/hero-slides/video`, file)).url;
  },
  async uploadCampaignImage(file) {
    return (await uploadMultipart(`${ROUTES.productMedia}/campaigns/image`, file)).url;
  },
  async uploadCampaignVideo(file) {
    return (await uploadMultipart(`${ROUTES.productMedia}/campaigns/video`, file)).url;
  },
  async uploadPromoTileImage(file) {
    return (await uploadMultipart(`${ROUTES.productMedia}/promo-tiles/image`, file)).url;
  },
  async uploadCategoryImage(file) {
    return (await uploadMultipart(`${ROUTES.productMedia}/categories/image`, file)).url;
  }
};
var campaignGalleryApi = {
  list(campaignId) {
    return http.get(`${ROUTES.productCampaigns}/${campaignId}/media`, { anonymous: true });
  },
  uploadImage(campaignId, file) {
    return uploadMultipart(`${ROUTES.productCampaigns}/${campaignId}/media/upload?isVideo=false`, file);
  },
  uploadVideo(campaignId, file) {
    return uploadMultipart(`${ROUTES.productCampaigns}/${campaignId}/media/upload?isVideo=true`, file);
  },
  addEmbed(campaignId, body) {
    return http.post(`${ROUTES.productCampaigns}/${campaignId}/media/embed`, body);
  },
  remove(campaignId, mediaId) {
    return deleteWithAuth(`${ROUTES.productCampaigns}/${campaignId}/media/${mediaId}`);
  },
  reorder(campaignId, orderedMediaIds) {
    return http.put(`${ROUTES.productCampaigns}/${campaignId}/media/reorder`, { orderedMediaIds });
  }
};

// src/api/cart.ts
var GUEST_SESSION_HEADER = "X-Guest-Session-Id";
var guestSessionListeners = /* @__PURE__ */ new Set();
function onGuestSessionMinted(listener) {
  guestSessionListeners.add(listener);
  return () => guestSessionListeners.delete(listener);
}
__name(onGuestSessionMinted, "onGuestSessionMinted");
function withGuestSession(guestSessionId) {
  return {
    headers: guestSessionId ? { [GUEST_SESSION_HEADER]: guestSessionId } : void 0,
    onHeaders: /* @__PURE__ */ __name((headers) => {
      const minted = headers.get(GUEST_SESSION_HEADER);
      if (minted) guestSessionListeners.forEach((l) => l(minted));
    }, "onHeaders")
  };
}
__name(withGuestSession, "withGuestSession");
var cartApi = {
  get() {
    return http.get(ROUTES.cart);
  },
  addItem(body, guestSessionId) {
    return http.post(`${ROUTES.cart}/items`, body, withGuestSession(guestSessionId));
  },
  removeItem(itemId, guestSessionId) {
    return http.delete(`${ROUTES.cart}/items/${itemId}`, withGuestSession(guestSessionId));
  },
  clear(guestSessionId) {
    return http.delete(ROUTES.cart, withGuestSession(guestSessionId));
  },
  applyCoupon(code, guestSessionId) {
    return http.post(`${ROUTES.cart}/coupon`, { code }, withGuestSession(guestSessionId));
  },
  removeCoupon(guestSessionId) {
    return http.delete(`${ROUTES.cart}/coupon`, withGuestSession(guestSessionId));
  },
  /** Called right after login with the guest session id the caller was carrying; unions
   * the guest cart into the now-logged-in user's cart. */
  merge(guestSessionId) {
    return http.post(`${ROUTES.cart}/merge`, { guestSessionId });
  },
  /** Customer-only (logged-in required, same as get()/merge()) — a saved list durable past
   * the active cart's Redis TTL, so guests have nowhere for this to persist to. */
  saveForLater(itemId) {
    return http.post(`${ROUTES.cart}/items/${itemId}/save-for-later`);
  },
  getSaved() {
    return http.get(`${ROUTES.cart}/saved`);
  },
  restoreSaved(savedItemId) {
    return http.post(`${ROUTES.cart}/saved/${savedItemId}/restore`);
  },
  removeSaved(savedItemId) {
    return http.delete(`${ROUTES.cart}/saved/${savedItemId}`);
  }
};

// src/api/orders.ts
var ordersApi = {
  create(body, options = {}) {
    const key = options.idempotencyKey ?? cryptoKey2();
    return http.post(ROUTES.orders, body, { ...options, idempotencyKey: key });
  },
  /** A customer's own orders. Manager/admin get every order (staff-wide) unless
   * `customerId` scopes it to one customer — ignored server-side for a non-staff caller. */
  list(filters = {}) {
    const params = new URLSearchParams();
    if (filters.status) params.set("status", filters.status);
    if (filters.cursor) params.set("cursor", filters.cursor);
    if (filters.pageSize) params.set("pageSize", String(filters.pageSize));
    if (filters.customerId) params.set("customerId", filters.customerId);
    const qs = params.toString();
    return http.get(`${ROUTES.orders}${qs ? `?${qs}` : ""}`);
  },
  /** The owning customer, or manager/admin — the backend 403s a mismatch. */
  /** Anonymous tracking — the order number plus the e-mail the order was placed with. 404 on any mismatch. */
  track(orderNumber, email) {
    const q = new URLSearchParams({ orderNumber, email });
    return http.get(`${ROUTES.orders}/track?${q.toString()}`, { anonymous: true });
  },
  get(id) {
    return http.get(`${ROUTES.orders}/${id}`);
  },
  /** The caller's own order count (self-scoped only — no customerId param), optionally
   * filtered by status. Real data for the storefront nav badge. */
  myCount(status) {
    return http.get(`${ROUTES.orders}/my-count${status ? `?status=${status}` : ""}`);
  },
  /** Admin/manager only. */
  updateStatus(id, body) {
    return http.put(`${ROUTES.orders}/${id}/status`, body);
  },
  /** The owning customer only. */
  cancel(id, body) {
    return http.put(`${ROUTES.orders}/${id}/cancel`, body);
  },
  /** Append-only audit trail, newest first, cursor-paginated. */
  getHistory(id, cursor, pageSize = 20) {
    const params = new URLSearchParams({ pageSize: String(pageSize) });
    if (cursor) params.set("cursor", cursor);
    return http.get(`${ROUTES.orders}/${id}/history?${params.toString()}`);
  },
  /** Anonymous "Hot Sellers" widget — real units-sold from OrderItems, no login required
   * (gateway override of the parent /api/v1/orders auth gate — see appsettings.json). */
  topProducts(limit = 8, days = 30) {
    return http.get(`${ROUTES.orders}/analytics/top-products?limit=${limit}&days=${days}`, { anonymous: true });
  },
  /** Manager+ only — admin dashboard revenue/order overview. */
  analyticsSummary(days = 30) {
    return http.get(`${ROUTES.orders}/analytics/summary?days=${days}`);
  },
  /** Manager+ only — order-lifecycle funnel (Placed → Processing → Completed / Cancelled). */
  analyticsFunnel(days = 30) {
    return http.get(`${ROUTES.orders}/analytics/funnel?days=${days}`);
  },
  /** Manager+ only — monthly retention by first-order cohort. */
  analyticsCohorts(months = 6) {
    return http.get(`${ROUTES.orders}/analytics/cohorts?months=${months}`);
  },
  /** Manager+ only — dashboard KPI row (today/this-week orders+revenue, pending backlog,
   * active/total customers). */
  analyticsOverview() {
    return http.get(`${ROUTES.orders}/analytics/overview`);
  },
  /** Manager+ only — cross-order audit log (every order's status changes, not just one). */
  allHistory(filters = {}) {
    const params = new URLSearchParams();
    if (filters.status) params.set("status", filters.status);
    if (filters.cursor) params.set("cursor", filters.cursor);
    if (filters.pageSize) params.set("pageSize", String(filters.pageSize));
    const qs = params.toString();
    return http.get(`${ROUTES.orders}/history${qs ? `?${qs}` : ""}`);
  }
};
function cryptoKey2() {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) return crypto.randomUUID();
  return `order-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}
__name(cryptoKey2, "cryptoKey");

// src/api/loyalty.ts
var loyaltyApi = {
  listTiers() {
    return http.get(`${ROUTES.loyalty}/tiers`, { anonymous: true });
  },
  createTier(body) {
    return http.post(`${ROUTES.loyalty}/tiers`, body);
  },
  updateTier(id, body) {
    return http.put(`${ROUTES.loyalty}/tiers/${id}`, body);
  },
  removeTier(id) {
    return http.delete(`${ROUTES.loyalty}/tiers/${id}`);
  },
  me() {
    return http.get(`${ROUTES.loyalty}/me`);
  },
  enroll() {
    return http.post(`${ROUTES.loyalty}/enroll`);
  },
  listMembers() {
    return http.get(`${ROUTES.loyalty}/members`);
  }
};

// src/api/referrals.ts
var referralsApi = {
  me() {
    return http.get(`${ROUTES.referrals}/me`);
  },
  redeem(code) {
    return http.post(`${ROUTES.referrals}/redeem`, { code });
  },
  stats() {
    return http.get(`${ROUTES.referrals}/stats`);
  }
};

// src/api/reviews.ts
var reviewsApi = {
  list(productId, cursor, pageSize = 10) {
    const params = new URLSearchParams({ pageSize: String(pageSize) });
    if (cursor) params.set("cursor", cursor);
    return http.get(`${ROUTES.products}/${productId}/reviews?${params.toString()}`, { anonymous: true });
  },
  /** The owning customer only (401 for anonymous — the gateway requires a real login for the
   * whole /orders-shaped write path here too). */
  create(productId, body) {
    return http.post(`${ROUTES.products}/${productId}/reviews`, body);
  },
  /** Whether the signed-in customer has already reviewed this product. */
  hasReviewed(productId) {
    return http.get(`${ROUTES.products}/${productId}/reviews/mine`);
  },
  /** Manager+ only — every review across every product, for moderation. */
  moderationList(cursor, pageSize = 20) {
    const params = new URLSearchParams({ pageSize: String(pageSize) });
    if (cursor) params.set("cursor", cursor);
    return http.get(`${ROUTES.productReviews}/moderation?${params.toString()}`);
  },
  /** Manager+ only. */
  setHidden(reviewId, hidden) {
    return http.put(`${ROUTES.productReviews}/${reviewId}/hide`, { hidden });
  },
  /** Manager+ only. Publishes (or edits) the public store reply — whether typed from scratch
   * or edited from the AI-suggested draft. */
  publishReply(reviewId, reply) {
    return http.put(`${ROUTES.productReviews}/${reviewId}/reply`, { reply });
  }
};

// src/api/wishlist.ts
var wishlistApi = {
  /** Cheap product-id set for heart-icon state across listing pages. */
  ids() {
    return http.get(`${ROUTES.wishlist}/ids`);
  },
  /** Full product cards, most-recently-added first — the wishlist page. */
  list() {
    return http.get(ROUTES.wishlist);
  },
  add(productId) {
    return http.post(`${ROUTES.wishlist}/${productId}`);
  },
  remove(productId) {
    return http.delete(`${ROUTES.wishlist}/${productId}`);
  },
  /** Manager+ only — admin dashboard "most wishlisted" widget. */
  topWishlisted(limit = 8) {
    return http.get(`${ROUTES.wishlist}/analytics/top?limit=${limit}`);
  }
};

// src/api/newsletter.ts
var newsletterApi = {
  subscribe(email, source) {
    return http.post(ROUTES.newsletter.subscribe, { email, source }, { anonymous: true });
  },
  unsubscribe(id) {
    return http.post(ROUTES.newsletter.unsubscribe(id), void 0, { anonymous: true });
  },
  /** Manager+ only. */
  list(activeOnly = true) {
    return http.get(ROUTES.newsletter.list(activeOnly));
  }
};

// src/api/common/SignalRServiceBase.ts
import { HubConnectionBuilder, LogLevel, HttpTransportType } from "@microsoft/signalr";

// src/utils/cn.ts
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

// src/utils/urlUtils.ts
var removeTrailingApi = /* @__PURE__ */ __name((baseUrl) => {
  if (!baseUrl || typeof baseUrl !== "string") {
    return baseUrl || "";
  }
  try {
    const urlObj = new URL(baseUrl);
    let pathname = urlObj.pathname;
    if (pathname.endsWith("/api/")) {
      pathname = pathname.substring(0, pathname.length - 5);
    } else if (pathname.endsWith("/api")) {
      pathname = pathname.substring(0, pathname.length - 4);
    }
    if (pathname === "") {
      pathname = "/";
    } else if (!pathname.startsWith("/")) {
      pathname = "/" + pathname;
    }
    if (pathname !== "/" && !pathname.endsWith("/")) {
      pathname += "/";
    }
    urlObj.pathname = pathname;
    return urlObj.toString();
  } catch (error) {
    return baseUrl.replace(/\/api\/?$/, "");
  }
}, "removeTrailingApi");
var convertToAbsoluteUrl = /* @__PURE__ */ __name((relativeUrl) => {
  if (!relativeUrl || typeof relativeUrl !== "string") {
    return relativeUrl || "";
  }
  if (relativeUrl.startsWith("http://") || relativeUrl.startsWith("https://")) {
    return relativeUrl;
  }
  const baseUrlWithoutApi = removeTrailingApi(API_CONFIG.baseURL);
  let baseUrl = baseUrlWithoutApi;
  if (!baseUrl.endsWith("/")) {
    baseUrl += "/";
  }
  let urlPath = relativeUrl;
  if (urlPath.startsWith("/")) {
    urlPath = urlPath.substring(1);
  }
  return `${baseUrl}${urlPath}`;
}, "convertToAbsoluteUrl");

// src/api/common/SignalRServiceBase.ts
var _SignalRServiceBase = class _SignalRServiceBase {
  constructor(options) {
    __publicField(this, "connection", null);
    __publicField(this, "isConnecting", false);
    __publicField(this, "isManuallyDisconnected", false);
    __publicField(this, "reconnectAttempts", 0);
    __publicField(this, "maxReconnectAttempts");
    __publicField(this, "reconnectInterval");
    __publicField(this, "hubName");
    __publicField(this, "fullHubUrl");
    // Added to store full URL
    __publicField(this, "transportStrategies");
    __publicField(this, "loggingLevel");
    __publicField(this, "onAuthTokenRequired");
    __publicField(this, "onAuthTokenMissing");
    __publicField(this, "eventCallbacks", /* @__PURE__ */ new Map());
    __publicField(this, "subscriptions", /* @__PURE__ */ new Set());
    __publicField(this, "connectionState", "Disconnected");
    __publicField(this, "connectionRetryTimeout", null);
    const baseUrl = convertToAbsoluteUrl(API_CONFIG.baseURL);
    this.fullHubUrl = `${baseUrl}${options.hubName}`;
    this.hubName = options.hubName;
    this.maxReconnectAttempts = options.reconnectAttempts || 3;
    this.reconnectInterval = options.reconnectInterval || 3e3;
    this.loggingLevel = options.loggingLevel || LogLevel.Information;
    this.onAuthTokenRequired = options.onAuthTokenRequired || (async () => null);
    this.onAuthTokenMissing = options.onAuthTokenMissing || (() => {
      console.warn("No auth token handler provided");
    });
    this.transportStrategies = options.transportStrategies || [
      {
        name: "WebSockets",
        transport: HttpTransportType.WebSockets,
        skipNegotiation: true
        // WebSockets can skip negotiation
      },
      {
        name: "LongPolling",
        transport: HttpTransportType.LongPolling,
        skipNegotiation: false
        // Don't skip for LongPolling
      },
      {
        name: "ServerSentEvents",
        transport: HttpTransportType.ServerSentEvents,
        skipNegotiation: false
        // Don't skip for SSE
      }
    ];
  }
  async connect() {
    if (this.connection?.state === "Connected") {
      console.log(`\u{1F504} ${this.hubName}: Already connected`);
      return true;
    }
    if (this.isConnecting) {
      console.log(`\u{1F504} ${this.hubName}: Already connecting`);
      return false;
    }
    if (this.isManuallyDisconnected) {
      console.log(`\u{1F50C} ${this.hubName}: Connection was manually disconnected, not reconnecting`);
      return false;
    }
    try {
      this.isConnecting = true;
      const token = await this.getAuthToken();
      if (!token) {
        console.warn(`\u26A0\uFE0F ${this.hubName}: No authentication token available, will not connect`);
        this.isConnecting = false;
        this.onAuthTokenMissing();
        return false;
      }
      console.log(`\u{1F517} ${this.hubName}: Connecting to:`, this.fullHubUrl);
      console.log(`\u{1F511} Token available:`, token ? "Yes (length: " + token.length + ")" : "No");
      const connection = await this.tryConnectWithFallback(this.fullHubUrl, token);
      if (!connection) {
        throw new Error("Failed to establish connection with any transport");
      }
      this.connection = connection;
      this.connectionState = "Connected";
      console.log(`\u2705 ${this.hubName}: Connected successfully`);
      console.log(`\u{1F4E1} Connection ID:`, this.connection.connectionId);
      console.log(`\u{1F680} Transport:`, this.getTransportType());
      this.setupCommonEventHandlers(connection);
      await this.setupCustomEventHandlers(connection);
      this.reconnectAttempts = 0;
      this.isConnecting = false;
      this.triggerEvent("Connected", {
        connectionId: this.connection.connectionId,
        hubUrl: this.fullHubUrl,
        timestamp: /* @__PURE__ */ new Date(),
        transport: this.getTransportType()
      });
      return true;
    } catch (error) {
      console.error(`\u274C ${this.hubName}: Connection failed`);
      console.error("Error:", error.message);
      this.isConnecting = false;
      this.connectionState = "Disconnected";
      this.triggerEvent("ConnectionError", {
        error: error.message,
        hubName: this.hubName,
        hubUrl: this.fullHubUrl,
        timestamp: /* @__PURE__ */ new Date(),
        reconnectAttempts: this.reconnectAttempts
      });
      if (!this.isManuallyDisconnected && this.reconnectAttempts < this.maxReconnectAttempts) {
        this.reconnectAttempts++;
        console.log(`\u{1F504} Will retry connection in ${this.reconnectInterval}ms (attempt ${this.reconnectAttempts}/${this.maxReconnectAttempts})`);
        if (this.connectionRetryTimeout !== null) {
          clearTimeout(this.connectionRetryTimeout);
          this.connectionRetryTimeout = null;
        }
        this.connectionRetryTimeout = setTimeout(() => {
          console.log(`\u{1F517} ${this.hubName}: Attempting reconnection (${this.reconnectAttempts}/${this.maxReconnectAttempts})...`);
          this.handleReconnection();
        }, this.reconnectInterval);
      } else if (this.reconnectAttempts >= this.maxReconnectAttempts) {
        console.warn(`\u26A0\uFE0F ${this.hubName}: Max reconnection attempts reached (${this.maxReconnectAttempts})`);
        this.triggerEvent("MaxReconnectAttemptsReached", {
          hubName: this.hubName,
          attempts: this.reconnectAttempts,
          timestamp: /* @__PURE__ */ new Date()
        });
      }
      return false;
    }
  }
  async tryConnectWithFallback(hubUrl, token) {
    let lastError = null;
    for (const strategy of this.transportStrategies) {
      try {
        console.log(`\u{1F504} ${this.hubName}: Trying ${strategy.name} transport...`);
        const connection = new HubConnectionBuilder().withUrl(hubUrl, {
          accessTokenFactory: /* @__PURE__ */ __name(() => token, "accessTokenFactory"),
          transport: strategy.transport,
          skipNegotiation: strategy.skipNegotiation,
          withCredentials: true,
          headers: {
            "X-SignalR-User-Agent": "AgroRange-ReactNative/1.0"
          }
        }).withAutomaticReconnect({
          nextRetryDelayInMilliseconds: /* @__PURE__ */ __name((retryContext) => {
            if (retryContext.previousRetryCount === 0) return 0;
            if (retryContext.previousRetryCount === 1) return 2e3;
            if (retryContext.previousRetryCount === 2) return 5e3;
            return 1e4;
          }, "nextRetryDelayInMilliseconds")
        }).configureLogging(this.loggingLevel).build();
        console.log(`\u{1F680} ${this.hubName}: Starting connection with ${strategy.name}...`);
        const timeoutPromise = new Promise((_, reject) => {
          setTimeout(() => reject(new Error(`Connection timeout for ${strategy.name} (10s)`)), 1e4);
        });
        const connectionPromise = connection.start();
        await Promise.race([connectionPromise, timeoutPromise]);
        console.log(`\u2705 ${this.hubName}: Successfully connected using ${strategy.name}`);
        return connection;
      } catch (error) {
        console.error(`\u274C ${this.hubName}: ${strategy.name} connection failed:`, error.message);
        if (error.message.includes("negotiation") || error.message.includes("404")) {
          console.warn(`\u26A0\uFE0F Negotiation failed for ${strategy.name}. Check if endpoint exists: ${hubUrl}`);
          console.warn(`   Ensure the server has CORS enabled and SignalR endpoints are mapped`);
        }
        lastError = error;
        await new Promise((resolve) => setTimeout(resolve, 1e3));
      }
    }
    throw lastError || new Error("All transport strategies failed");
  }
  getTransportType() {
    if (!this.connection) return "Unknown";
    try {
      const transport = this.connection._connection?.transport;
      return transport ? transport.name : "Unknown";
    } catch {
      return "Unknown";
    }
  }
  setupCommonEventHandlers(connection) {
    connection.onclose((error) => {
      console.log(`\u{1F50C} ${this.hubName}: Connection closed`, error?.message || "");
      this.connection = null;
      this.connectionState = "Disconnected";
      if (!this.isManuallyDisconnected) {
        this.triggerEvent("ConnectionClosed", {
          error: error?.message,
          wasClean: error === void 0 || error === null,
          timestamp: /* @__PURE__ */ new Date()
        });
      }
    });
    connection.onreconnecting((error) => {
      console.log(`\u{1F504} ${this.hubName}: Reconnecting...`, error?.message || "");
      this.connectionState = "Reconnecting";
      this.triggerEvent("Reconnecting", {
        error: error?.message,
        timestamp: /* @__PURE__ */ new Date()
      });
    });
    connection.onreconnected((connectionId) => {
      console.log(`\u2705 ${this.hubName}: Reconnected successfully`);
      this.connectionState = "Connected";
      this.reconnectAttempts = 0;
      this.triggerEvent("Reconnected", {
        connectionId,
        timestamp: /* @__PURE__ */ new Date()
      });
    });
  }
  async setupCustomEventHandlers(connection) {
  }
  async handleReconnection() {
    try {
      console.log(`\u{1F504} ${this.hubName}: Attempting reconnection (${this.reconnectAttempts}/${this.maxReconnectAttempts})...`);
      await this.connect();
    } catch (error) {
      console.error(`\u274C ${this.hubName}: Reconnection attempt ${this.reconnectAttempts} failed:`, error);
    }
  }
  async getAuthToken() {
    try {
      return await this.onAuthTokenRequired();
    } catch (error) {
      console.error(`${this.hubName}: Error getting auth token:`, error);
      return null;
    }
  }
  // Event management
  triggerEvent(eventName, data) {
    const callbacks = this.eventCallbacks.get(eventName) || [];
    callbacks.forEach((callback) => {
      try {
        callback(data);
      } catch (error) {
        console.error(`${this.hubName}: Error in ${eventName} callback:`, error);
      }
    });
  }
  on(eventName, callback) {
    if (!this.eventCallbacks.has(eventName)) {
      this.eventCallbacks.set(eventName, []);
    }
    this.eventCallbacks.get(eventName).push(callback);
  }
  off(eventName, callback) {
    if (!callback) {
      this.eventCallbacks.delete(eventName);
      return;
    }
    const callbacks = this.eventCallbacks.get(eventName) || [];
    const index = callbacks.indexOf(callback);
    if (index > -1) {
      callbacks.splice(index, 1);
    }
  }
  // Connection management
  async disconnect() {
    console.log(`\u{1F50C} ${this.hubName}: Disconnecting...`);
    this.isManuallyDisconnected = true;
    if (this.connectionRetryTimeout !== null) {
      clearTimeout(this.connectionRetryTimeout);
      this.connectionRetryTimeout = null;
    }
    this.eventCallbacks.clear();
    this.subscriptions.clear();
    if (this.connection) {
      try {
        await this.connection.stop();
        console.log(`\u2705 ${this.hubName}: Disconnected successfully`);
      } catch (error) {
        console.error(`\u274C ${this.hubName}: Error during disconnect:`, error);
      } finally {
        this.connection = null;
        this.connectionState = "Disconnected";
      }
    }
    this.reconnectAttempts = 0;
  }
  // Reset for reconnection (call this after login)
  resetConnection() {
    this.isManuallyDisconnected = false;
    this.reconnectAttempts = 0;
    console.log(`\u{1F504} ${this.hubName}: Connection reset, ready for reconnection`);
  }
  async invoke(methodName, ...args) {
    if (this.connection?.state === "Connected") {
      try {
        console.log(`\u{1F4E4} ${this.hubName}: Invoking ${methodName}`);
        return await this.connection.invoke(methodName, ...args);
      } catch (error) {
        console.error(`\u274C ${this.hubName}: Failed to invoke ${methodName}:`, error);
        throw error;
      }
    } else {
      throw new Error(`Cannot invoke ${methodName} - connection not established`);
    }
  }
  send(methodName, ...args) {
    return this.invoke(methodName, ...args);
  }
  // Status getters
  getConnectionState() {
    return this.connectionState;
  }
  isConnected() {
    return this.connectionState === "Connected";
  }
  getConnectionInfo() {
    return {
      hubName: this.hubName,
      fullHubUrl: this.fullHubUrl,
      state: this.connectionState,
      isConnecting: this.isConnecting,
      isManuallyDisconnected: this.isManuallyDisconnected,
      reconnectAttempts: this.reconnectAttempts,
      maxReconnectAttempts: this.maxReconnectAttempts,
      connectionId: this.connection?.connectionId,
      transport: this.getTransportType(),
      subscriptions: this.subscriptions.size
    };
  }
  // Subscription management
  addSubscription(key) {
    this.subscriptions.add(key);
  }
  removeSubscription(key) {
    this.subscriptions.delete(key);
  }
  clearSubscriptions() {
    this.subscriptions.clear();
  }
  getSubscriptionStatus() {
    return {
      isSubscribed: this.subscriptions.size > 0,
      subscriptions: Array.from(this.subscriptions)
    };
  }
  async heartbeat() {
    if (this.isConnected()) {
      try {
        const heartbeatPromise = this.invoke("Heartbeat");
        const timeoutPromise = new Promise((_, reject) => {
          setTimeout(() => reject(new Error("Heartbeat timeout")), 3e4);
        });
        await Promise.race([heartbeatPromise, timeoutPromise]);
        console.log(`\u{1F493} ${this.hubName}: Heartbeat sent and acknowledged`);
      } catch (error) {
        console.error(`\u274C ${this.hubName}: Heartbeat failed:`, error);
        if (error.message.includes("timeout") || error.message.includes("Server timeout")) {
          console.warn(`\u26A0\uFE0F ${this.hubName}: Heartbeat timeout, connection might be unstable`);
        }
      }
    }
  }
};
__name(_SignalRServiceBase, "SignalRServiceBase");
var SignalRServiceBase = _SignalRServiceBase;

// src/api/common/ChatHubService.ts
var _ChatHubService = class _ChatHubService extends SignalRServiceBase {
  constructor(options = {}) {
    super({ ...options, hubName: "/hubs/chat" });
  }
  async setupCustomEventHandlers(connection) {
    connection.on("OnContactReceived", (payload) => {
      this.triggerEvent("OnContactReceived", payload);
    });
  }
};
__name(_ChatHubService, "ChatHubService");
var ChatHubService = _ChatHubService;

// src/api/common/MessagesHub.ts
import * as signalR from "@microsoft/signalr";
function connectMessagesHub(accessToken, onMessage) {
  const connection = new signalR.HubConnectionBuilder().withUrl(`${API_BASE_URL}/hubs/chat`, { accessTokenFactory: /* @__PURE__ */ __name(() => accessToken, "accessTokenFactory") }).withAutomaticReconnect().configureLogging(signalR.LogLevel.Warning).build();
  connection.on("OnMessageReceived", onMessage);
  connection.start().catch((err) => {
    console.error("[MessagesHub] connection failed:", err);
  });
  return connection;
}
__name(connectMessagesHub, "connectMessagesHub");

// src/api/common/WorkerHubClient.ts
import * as signalR2 from "@microsoft/signalr";
function connectWorkerHub(accessToken, handlers) {
  const connection = new signalR2.HubConnectionBuilder().withUrl(`${API_BASE_URL}/hubs/worker`, { accessTokenFactory: /* @__PURE__ */ __name(() => accessToken, "accessTokenFactory") }).withAutomaticReconnect().configureLogging(signalR2.LogLevel.Warning).build();
  if (handlers.onPaymentReleased) connection.on("OnPaymentReleased", handlers.onPaymentReleased);
  if (handlers.onLocationUpdated) connection.on("OnLocationUpdated", handlers.onLocationUpdated);
  connection.start().catch((err) => {
    console.error("[WorkerHubClient] connection failed:", err);
  });
  return connection;
}
__name(connectWorkerHub, "connectWorkerHub");

// src/api/common/InventoryHub.ts
import * as signalR3 from "@microsoft/signalr";
function connectInventoryHub(accessToken, onLowStock) {
  const connection = new signalR3.HubConnectionBuilder().withUrl(`${API_BASE_URL}/hubs/inventory`, { accessTokenFactory: /* @__PURE__ */ __name(() => accessToken, "accessTokenFactory") }).withAutomaticReconnect().configureLogging(signalR3.LogLevel.Warning).build();
  connection.on("OnLowStock", onLowStock);
  connection.start().catch((err) => {
    console.error("[InventoryHub] connection failed:", err);
  });
  return connection;
}
__name(connectInventoryHub, "connectInventoryHub");
export {
  API_BASE_URL,
  API_CONFIG,
  ApiError,
  AuthError,
  ChatHubService,
  GUEST_SESSION_HEADER,
  NetworkError,
  REQUEST_TIMEOUT_MS,
  ROUTES,
  RateLimitError,
  SignalRServiceBase,
  ValidationError,
  aiApi,
  analyticsApi,
  authApi,
  billingApi,
  blogApi,
  bookingApi,
  campaignGalleryApi,
  campaignsApi,
  cartApi,
  catalogAdminApi,
  connectInventoryHub,
  connectMessagesHub,
  connectWorkerHub,
  contactsApi,
  crmApi,
  decodeUser,
  discountsApi,
  ensureFreshToken,
  errorFromResponse,
  http,
  imagesApi,
  jobPostingsApi,
  locationsApi,
  loyaltyApi,
  mediaApi,
  messagesApi,
  newsletterApi,
  notificationsApi,
  onAuthFailure,
  onGuestSessionMinted,
  ordersApi,
  productMediaApi,
  productsApi,
  referralsApi,
  refreshTokens,
  reportsApi,
  reviewsApi,
  schedulingApi,
  siteApi,
  subscriptionsApi,
  tenantsApi,
  testimonialsApi,
  tokenStore,
  userMessage,
  usersApi,
  wishlistApi,
  workersApi
};
//# sourceMappingURL=index.js.map